import React, { useState, useEffect } from "react";
import { inputFormat, inputCustomFormat, billPlease, moneyFormat } from "../../ultil";
import _ from "lodash";
import Loading from "../Loading";
import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  AppBar,
  Box,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Modal,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const style = {
  height: '100%',
  marginRight: 'auto',
  marginLeft: 'auto',
  bgcolor: 'background.paper',
  overflow: 'auto',
  maxWidth: '600px',
  bgcolor: '#F6F6F6',
  position: 'relative',
  outline: 'none'
};

const Topping = ({
  dataDetail,
  setDataDetail,
  setAddCart,
  addCart,
  setIsOpenTopping,
  infoStore,
  index = 0,
  orderType,
  user,
  discountMoneyStore,
  isEditTopping,
  setIsEditTopping,
  indexEditTopping,
  setIndexEditTopping,
  setIsCart,
  isEditToppingInCart,
  setIsEditToppingInCart
}) => {
  const [count, setCount] = useState(0);

  const [checkCount, setCheckCount] = useState(0);

  const [toppingSelected, setToppingSelected] = useState([]);

  useEffect(() => {
    setCheckCount(1);
    //push cac topping bat buoc vao
    if (!isEditTopping) {
      setCount(1);
      dataDetail.topping.map((item, i) => {
        dataDetail.topping[i].quantity = 0;
        dataDetail.topping[i].toppingSelected = [];
        dataDetail.topping[i].topping.map((t, j) => {
          dataDetail.topping[i].topping[j].quantity = 0;
          dataDetail.topping[i].topping[j].toppingSelected = [];
        });
        if (item.minSelect == 1) {
          var child = item.topping[0];
          item.quantity = 1;
          child.quantity = 1;
          item.toppingSelected = [child];
          toppingSelected.push(item);
          setToppingSelected(_.cloneDeep(toppingSelected));
        }
      });
    } else {
      setCount(dataDetail.quantity);
      setToppingSelected(_.cloneDeep(dataDetail.toppingSelected));
    }
  }, []);

  const addTopping = (parent, child) => {
    let tmp = [];
    if (toppingSelected.length == 0) {
      parent.quantity = 1;
      child.quantity = 1;
      parent.toppingSelected = [child];
      toppingSelected.push(parent);
    } else {
      var index = _.findIndex(toppingSelected, item => item._id === parent._id);
      if (index !== -1) {
        parent.quantity++;
        //thêm vao topping con
        var indexChild = _.findIndex(
          parent.toppingSelected,
          itemChild => itemChild._id === child._id
        );
        if (indexChild !== -1) {
          child.quantity++;
          parent.toppingSelected[indexChild] = child;
        } else {
          child.quantity = 1;
          parent.toppingSelected.push(child);
        }
        toppingSelected[index] = parent;
      } else {
        parent.quantity = 1;
        child.quantity = 1;
        parent.toppingSelected = [child];
        toppingSelected.push(parent);
      }
    }
    setToppingSelected(_.cloneDeep(toppingSelected));
  };

  const removeTopping = (parent, child) => {
    var index = _.findIndex(toppingSelected, item => item._id === parent._id);
    if (index !== -1) {
      parent.quantity--;
      if (parent.quantity == 0) {
        toppingSelected.splice(index, 1);
        child.quantity--;
        parent.toppingSelected.splice(0, 1);
      } else {
        var indexChild = _.findIndex(
          parent.toppingSelected,
          itemChild => itemChild._id === child._id
        );
        if (indexChild !== -1) {
          child.quantity--;
          if (child.quantity == 0) {
            parent.toppingSelected.splice(indexChild, 1);
          } else {
            parent.toppingSelected[indexChild] = child;
          }
        }
        toppingSelected[index] = parent;
      }
    }
    setToppingSelected(_.cloneDeep(toppingSelected));
  };

  const changeTopping = (parent, child) => {
    let tmp = [];
    if (toppingSelected.length == 0) {
      parent.quantity = 1;
      child.quantity = 1;
      parent.toppingSelected = [child];
      toppingSelected.push(parent);
    } else {
      var index = _.findIndex(toppingSelected, item => item._id === parent._id);
      if (index !== -1) {
        child.quantity = 1;
        parent.toppingSelected = [child];
        parent.topping.map((t, i) => {
          if (t._id != child._id) {
            t.quantity = 0;
          }
        });
        toppingSelected[index] = parent;
      }
    }

    setToppingSelected(_.cloneDeep(toppingSelected));
  };

  const btnOffDetail = () => {
    setDataDetail({});
    setCount(dataDetail.quantity);
    setIsOpenTopping(false);
    setIsEditTopping(false);
    document.body.style.overflow = "auto";
    if (isEditToppingInCart) {
      setIsCart(1);
      setIsEditToppingInCart(false);
    }
  };

  const btnAddToCard = () => {
    let countIsAuthen = checkCount;
    countIsAuthen = countIsAuthen + 1;
    setCheckCount(countIsAuthen);
    let addCount = count;
    addCount = addCount + 1;
    setCount(_.cloneDeep(addCount));
  };

  const btnsubmit = data => {
    if (isEditTopping) {
      addCart.splice(indexEditTopping, 1);
      setAddCart(_.cloneDeep(addCart));
    }
    if (count > 0) {
      var index = _.findIndex(
        addCart,
        item =>
          item._id === data._id &&
          _.isEqual(item.toppingSelected, toppingSelected)
      );

      if (index !== -1) {
        data.quantity += count;
        addCart[index].quantity += count;
      } else {
        data.toppingSelected = toppingSelected;
        data.quantity = count;
        addCart.push(data);
      }
    }
    localStorage.setItem("list-carts", JSON.stringify(addCart));
    setAddCart(_.cloneDeep(addCart));
    btnOffDetail(data);
  };

  const removeFromCart = data => {
    if (count >= 1) {
      let removeCount = count;
      removeCount = count - 1;
      setCount(_.cloneDeep(removeCount));
    } else {
      data.quantity = 0;
    }
  };

  const billTopping = () => {
    let sum = dataDetail.pricePromote;
    toppingSelected.map((item, i) => {
      item.toppingSelected.map((t, j) => {
        sum += t.price * t.quantity;
      });
    });
    return sum * count;
  };
  let showPrice = dataDetail.pricePromote, oldPrice = dataDetail.price === dataDetail.pricePromote ? null : dataDetail.price, basePrice = billTopping()

  return (
    <>
    <Box sx={style}>
    <Box sx={{position: 'relative', marginBottom: '64px'}}>
      <AppBar
        position="sticky"
        color="inherit"
      >
        <Toolbar sx={{minHeight: '52px'}}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={btnOffDetail}
          >
            <ArrowBackIcon fontSize="large"/>
          </IconButton>
          <TextTitle1 variant="h5" component="div">
            Chi tiết món
          </TextTitle1>

        </Toolbar>
      </AppBar>
      <Box>
        <img width="100%" height="auto" src={typeof dataDetail.images === 'string' ? dataDetail.images : dataDetail.images[0]}/>
        <Box sx={{ bgcolor: '#ffffff', padding: '16px'}} p={2}>
          <Box sx={{display: 'flex', alignItems: 'start', cursor: 'pointer'}}>
            <Box sx={{flexGrow: 1}}>
              <TextHead component="strong">
                {dataDetail.name}
              </TextHead>
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
            {
              showPrice && <TextHead component="strong" color={"#000000"}>
                {moneyFormat(showPrice)}
              </TextHead>
            }
            {
              oldPrice && <TextPriceOld component="span" color="#929394">
                {moneyFormat(oldPrice)}
              </TextPriceOld>
            }
            </Box>
          </Box>
          <Box mt={1} sx={{bgcolor: '#ffffff'}}>
            <TextBody2>
              {dataDetail.description || 'Không có mô tả'}
            </TextBody2>
          </Box>
        </Box>
      </Box>
      {
        !_.isEmpty(dataDetail.topping) &&
        dataDetail.topping.map((faAttr, i)=>{
          const {name, isRequire, maxSelect, minSelect,...toppingItem} = faAttr
          return <Box key={i} mt={1} sx={{bgcolor: '#ffffff', padding: '16px'}}>
            <TextBody>
              {name}
            </TextBody>
            <TextBody2 color="#929394">
              {isRequire ? 'Bắt buộc' : 'Không bắt buộc'}, tối đa {maxSelect}
            </TextBody2>
            {
              minSelect === maxSelect && maxSelect === 1?
              <ToppingRadio minSelect={minSelect} maxSelect={maxSelect} onChangeTopping={(child)=>changeTopping(faAttr, child)} data={toppingItem.topping}/>
              :
              maxSelect === 1?
              <ToppingBox minSelect={minSelect} maxSelect={maxSelect} onToggleTopping={(child)=>child.quantity ? removeTopping(faAttr,child) : addTopping(faAttr,child)} data={toppingItem.topping}/>
              :
              <ToppingMultiple minSelect={minSelect} maxSelect={maxSelect} onAddTopping={(child)=>addTopping(faAttr,child)} onMinusTopping={(child)=>removeTopping(faAttr,child)} data={toppingItem.topping}/>
            }
          </Box>
        })
      }
      <Box sx={{position: 'fixed', maxWidth:'600px', width: '100%', bottom: 0, display: 'flex', bgcolor: '#ffffff', padding: '12px 16px', zIndex: 1}}>
        <ButtonGroup size="small" variant="text" aria-label="text button group">
          <IconButton onClick={(e)=>{
            e.stopPropagation()
            removeFromCart(dataDetail)
          }}><i className="icon-minus-square" style={{fontSize: '24px', color: '#b0bec5'}}/></IconButton>
          <IconButton><TextQuantity component="span">{count}</TextQuantity></IconButton>
          <IconButton onClick={(e)=>{
            e.stopPropagation()
            btnAddToCard()
          }}><i className="icon-add-square" style={{fontSize: '24px', color: '#1589D8'}}/></IconButton>
        </ButtonGroup>
        <ButtonGroup onClick={() => btnsubmit(dataDetail)} sx={{flexGrow: 1}} size="small" variant="text" aria-label="text button group">
          <Button fullWidth variant="contained" sx={{borderRadius: '16px', fontSize: '16px', bgcolor: '#1589D8'}}>
          {count == 0
            ? "Xóa khỏi giỏ hàng"
            : isEditTopping
            ? `Cập nhật • ${moneyFormat(basePrice)}`
            : `Thêm • ${moneyFormat(basePrice)}`}
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
    </Box>
  </>);
};
export default Topping;

const ToppingRadio = ({onChangeTopping, data}) => {
  return <Box>
    {
      data.map((attr, i)=>{
        const {_id, name, price, isAvailable, quantity,...othersAttr} = attr
        const checked = quantity > 0
        return <Box key={i} sx={{width: '100%'}}>
        <ButtonBase onClick={()=>onChangeTopping(attr)} disabled={!isAvailable} sx={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Radio checked={checked} sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }, borderRadius: '100%' }}/>
          <TextBody2 sx={{flexGrow: 1}}>{name}</TextBody2>
          <TextBody2>{moneyFormat(price)}</TextBody2>
        </ButtonBase>
        {i < data.length - 1 && <Divider/>}
        </Box>
      })
    }
  </Box>
}

const ToppingBox = ({onToggleTopping, data}) => {
  return <Box mt={1}>
  {
    data.map((attr, i)=>{
      const {_id, name, price, isAvailable, quantity, ...othersAttr} = attr
      const checked = quantity > 0
      return <Box key={i} sx={{width: '100%'}}>
      <FormGroup>
        <ButtonBase onClick={()=>onToggleTopping(attr)} sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Checkbox checked={checked} sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }, borderRadius: '100%' }}/>
          <TextBody2 sx={{flexGrow: 1}}>{name}</TextBody2>
          <TextBody2>{moneyFormat(price)}</TextBody2>
        </ButtonBase>
      </FormGroup>
      {i < data.length - 1 && <Divider/>}
      </Box>
    })
  }
  </Box>;
}

const ToppingMultiple = ({onAddTopping, onMinusTopping, maxSelect, minSelect, data}) => {

  return <Box mt={1}>
  {
    data.map((attr, i)=>{
      const {_id, name, price, isAvailable, quantity, ...othersAttr} = attr
      return <FormGroup key={_id}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Box sx={{flexGrow: 1}}>
          <TextBody2>{name}</TextBody2>
          <TextBody2>{moneyFormat(price)}</TextBody2>
          </Box>

          <ButtonGroup size="small" variant="text" aria-label="text button group">
          {
            quantity > 0 ?<>
            <IconButton disabled={quantity <= minSelect} onClick={(e)=>{
              e.stopPropagation()
              onMinusTopping(attr)
            }}><i className="icon-minus-square" style={{fontSize: '24px', color: quantity <= minSelect ? '' : '#b0bec5'}}/></IconButton>
            <IconButton><TextQuantity sx={{fontSize: "20px"}} component="span">{quantity}</TextQuantity></IconButton>
            </>
            :
            null
          }
            <IconButton disabled={quantity >= maxSelect} onClick={(e)=>{
              e.stopPropagation()
              onAddTopping(attr)
            }}><i className="icon-add-square" style={{fontSize: '24px', color: quantity >= maxSelect ? '' :'#1589D8'}}/></IconButton>
          </ButtonGroup>
        </Box>
        {i < data.length - 1 && <Divider/>}
      </FormGroup>
    })
  }
  </Box>;
}
